import React from "react";
import { Button } from "@shadcn-in-nx/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function TicketPagination({ limit, offset, total, onPageChange }) {
    const { t } = useTranslation();
    const currentPage = Math.floor(offset / limit) + 1;
    const totalPages = Math.max(1, Math.ceil(total / limit));
    const hasPrev = offset > 0;
    const hasNext = offset + limit < total;

    return (
        <div className="flex items-center justify-between pt-4 gap-2">
            <span className="text-xs sm:text-sm text-muted-foreground">
                <span className="hidden sm:inline">
                    {t("admin.support.pagination", "Page {{current}} of {{total}} ({{count}} tickets)", {
                        current: currentPage, total: totalPages, count: total,
                    })}
                </span>
                <span className="sm:hidden">{currentPage}/{totalPages}</span>
            </span>
            <div className="flex items-center gap-2">
                <Button variant="outline" size="sm" disabled={!hasPrev} onClick={() => onPageChange(Math.max(0, offset - limit))}>
                    <ChevronLeft className="w-4 h-4 sm:mr-1" />
                    <span className="hidden sm:inline">{t("common.previous", "Previous")}</span>
                </Button>
                <Button variant="outline" size="sm" disabled={!hasNext} onClick={() => onPageChange(offset + limit)}>
                    <span className="hidden sm:inline">{t("common.next", "Next")}</span>
                    <ChevronRight className="w-4 h-4 sm:ml-1" />
                </Button>
            </div>
        </div>
    );
}
